<template>
  <div>
      <a-form class="form" :form="form">
        <template v-if="type == 'pwd'">
          <a-form-item class="marginBottom">
            <a-input
              :maxLength="11"
              v-decorator="['username',{ rules: [{validator:check }],validateTrigger: ['change', 'blur'] },]"
              placeholder="手机号码"
            >
              <!-- <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25); font-size: 20px;" /> -->
            </a-input>
          </a-form-item>

          <a-form-item class="marginBottom">
            <a-input
              v-decorator="['password',{ 
                rules: [{ required: true, message: '请输入登录密码!' }] },]"
              type="password"
              placeholder="密码"
            >
              <!-- <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /> -->
            </a-input>
          </a-form-item>
          <!-- 图片验证码 -->
          <!-- <a-form-item :style="type === 'pwd' ? 'margin-bottom:5px;' : ''" class="marginBottom">
            <div class="code">
              <a-input
                v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
                placeholder="验证码"
                @pressEnter="handleSubmit"
              >
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
              </a-input>
              <img @click="getCodeImg" style="width: 130px;height:36px;cursor:pointer;" :src="codeUrl">
            </div>
          </a-form-item> -->
        </template>
        <template v-else>
          <!-- 手机号登录--账号 -->
        <a-form-item class="marginBottom">
          <a-input
            :maxLength="11"
            v-decorator="['username',{ rules: [{validator:check }] ,
              validateTrigger: ['change', 'blur'] },
            ]"
            placeholder="手机号码"
          >
            <!-- <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25)" /> -->
          </a-input>
        </a-form-item>

        <!-- 图片验证码 -->
      <!-- <a-form-item :style="type === 'pwd' ? 'margin-bottom:5px;' : ''" class="marginBottom">
        <div class="code">
          <a-input
            v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
            placeholder="验证码"
            @pressEnter="handleSubmitForPhone"
          >
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
          </a-input>
          <img @click="getCodeImg" style="width: 130px;height:36px;cursor:pointer;" :src="codeUrl">
        </div>
      </a-form-item> -->
        <a-form-item class="marginBottom">
          <div class="code">
            <a-input
            v-decorator="['phonecode',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
            placeholder="请输入验证码"
          >
            <!-- <a-icon slot="prefix" type="mail" style="color:rgba(0,0,0,.25)" /> -->
          </a-input>
          <a-button type="primary" :disabled="countDownLoading" @click="getCode">{{countDownText}}</a-button>
          </div>
        </a-form-item>

      </template>

      <!-- 账号密码登录--账号 -->
    

      <a-form-item class="btn" style="width: 80%; margin: 50px auto 0 auto;">
        <a-button type="primary" v-if="type === 'phone'" :loading="loginLoding1" block @click="handleSubmitForPhone">{{buttonText}}</a-button>
        <a-button type="primary" v-if="type === 'pwd'" :loading="loginLoading2" block @click="handleSubmit">{{buttonText}}</a-button>
      </a-form-item>
      <!-- 忘记密码 -->
      <div style="width: 80%; margin: 10px auto;">
        <a-form-item v-if="type === 'pwd'" style="text-align: left;display: inline-block;margin-bottom: 0;">
          <span class="forget">
            <router-link to="/account/resetpwd">忘记密码?</router-link>
          </span>
        </a-form-item>
        <a-form-item style="text-align:center;display: inline-block;text-align: right;float:right;margin-bottom: 0;">
          <span>
            没有账号
            <router-link to="/account/register">去注册</router-link>
          </span>
        </a-form-item>
      </div>
    </a-form>
    <V5Dialog host="freetvks2vi2.verify5.com" :token="v5Token" :ssl="true" :trustLevel="5" ref="v5_1"></V5Dialog>
    <V5Dialog host="freetvks2vi2.verify5.com" :token="v5Token" :ssl="true" :trustLevel="5" ref="v5_2"></V5Dialog>

  </div>
</template>

<script>
import { getCodeImg, userNameLogin, getUserPhone, getV5Token, getUserV5Phone, getEnableConfig } from '@/api/account'
import {removeToken} from '@/utils/auth'
import {checkPhone} from '@/utils'
import {V5Dialog, V5Button} from 'verify5-vue';
export default {
  props: [ 'type' ],
  components: {V5Dialog, V5Button},
  data() {
    return {
      form: this.$form.createForm(this), // from表单实例
      buttonText: '登录', // 登录按钮文本
      loginLoding1: false, // 手机号登录按钮状态
      loginLoading2: false, // 密码登录按钮状态
      timer: null,
      countDownText: '获取验证码', // 获取验证码按钮文本
      countDownLoading: false,
      codeUrl: '', // 图形验证码url
      uuid: '', // uuid
      phoneVlaue:'',
      v5Token: '',
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      ifOpenCaptcha: true, // 是否开启验证码
    };
  },

  created() {
    this.getEnableConfig();
    // this.getCodeImg()
    this.countDown()
    this.clearData()
  },
  mounted(){
    // this.getV5Token();
  },
  methods: {
    getEnableConfig() {
      getEnableConfig('verifySwitch')
      .then(res => {
        this.ifOpenCaptcha = res.value === '1';
      })
      .catch(err => {
        console.log(err);
      })
    },
    getV5Token() {
      getV5Token()
        .then(res => {
          this.v5Token = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    gopwd(){
      that.$router.push('/')
    },
    clearData(){
      removeToken()
    },
    // 获取图片验证码
    async getCodeImg() {
      try {
        const data = await getCodeImg()
        this.codeUrl = `data:image/gif;base64,${data.img}`
        this.uuid = data.uuid
      } catch (error) {
        console.log("error")
      }
    },

    // 倒计时
    countDown() {
      let that = this
      try {
        let sendCode = that.$pub.getCookie('login_time')
        if(sendCode) {
          that.countDownLoading = true
          let count = parseInt(sendCode)
          var timer = setInterval(() => {
            // that.$cookies.set('login_time', count, {expires: 0.5})
            count--
            that.countDownText = `剩余${count}秒`
            if(count <= 0) {
              that.countDownText = '获取验证码'
              that.countDownLoading = false
              that.$cookies.remove('login_time')
              clearInterval(timer)
              that.timer = null
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 获取验证码
    getCode() {
      let that = this
      try {
        that.form.validateFields( ['username'], (err, params) => {
          if(!err){
            // let captchaId = '20218138370oRDx-Dq0IvboOQZY0aSI0Q**' //腾讯滑块验证码appid
            let captchaId = "2021813837" //腾讯滑块验证码appid
            //生成一个滑块验证码对象 
            let captcha = new TencentCaptcha(captchaId, (res)=> {
              if (res.ret === 0) {
                let newParams = {
                  scope:'quickLogin',
                  randstr: res.randstr,
                  ticket: res.ticket,
                  phoneNumber: params.username
                }
                getUserV5Phone(newParams)
                .then(res=>{
                  that.$cookies.set('login_time', 60, {expires: 0.5})
                  that.countDown()
                }).catch(error=>{
                  if(error.toString()=='Error: Request failed with status code 500'){
                    setTimeout(() => {
                      that.$router.push('/account/register')
                    }, 1000);
                  }
                })
				    }
			      });
            // 滑块显示
            captcha.show();
          }
        })
      } catch (error) {
        console.log(error)
      }
    },

    // 设置按钮状态
    setBtnStatus(status, text) {
      if(this.type === 'phone') {
        this.loginLoding1 = status
        this.buttonText = text
      } else if(this.type === 'pwd') {
        this.loginLoading2 = status
        this.buttonText = text
      }
    },

    // 账号密码登录
    handleSubmit() {
      let that = this
      try {
        that.form.validateFields( (err, params) => {
          if(!err) {
            if(that.ifOpenCaptcha) {
              that.openCaptcha().then(res => {
                that.setBtnStatus(true, '登录中')
                params['randstr'] = res.randstr;
                params['ticket'] = res.ticket;
                that.loginCallBack(params);
              })
            } else {
              that.loginCallBack(params);
            }
          } else {
            that.setBtnStatus(false, '登录')
          }
        })
      } catch (error) {
        that.setBtnStatus(false, '登录')
      }
    },
    // 开启验证码
    openCaptcha() {
      return new Promise((resolve, reject) => {
        // let captchaId = '20218138370oRDx-Dq0IvboOQZY0aSI0Q**' //腾讯滑块验证码appid
        let captchaId = "2021813837" //腾讯滑块验证码appid
        //生成一个滑块验证码对象
        const captcha = new TencentCaptcha(captchaId, (res)=> {
          if (res.ret === 0) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        // 滑块显示
        captcha.show();
      });
    },
    handleSubmitForPhone() {
      let that = this
      try {
        that.setBtnStatus(true, '登录中')
        that.form.validateFields( (err, params) => {
          if(!err) {
            this.loginForPhoneCallBack(params)
          } else {
            that.setBtnStatus(false, '登录')
          }
        })
      } catch (error) {
        that.setBtnStatus(false, '登录')
      }
    },

    // 手机号登录
    async loginForPhoneCallBack(params) {
      let that = this
      try {
        params.uuid = that.uuid;
        that.$store.dispatch('PhoneLogin', params).then(() => {
          that.setBtnStatus(false, '登录');
          that.$message.success('登录成功');
          setTimeout(() => {
            that.$router.replace({ path: '/' });
          }, 500);
        }).catch((err) => {
          console.log("err",err);
          this.setBtnStatus(false, '登录');
        })

      } catch (error) {
        this.setBtnStatus(false, '登录');
      }
    },

    // 登录提交回调
    async loginCallBack(params) {
      let that = this
      try {
        that.$store.dispatch('V5Login', params).then(() => {
          that.setBtnStatus(false, '登录')
          that.$message.success('登录成功')
          setTimeout(() => {
            that.$router.replace({ path: '/' })
          }, 500);
        }).catch((err) => {
          console.log("err",err)
          this.setBtnStatus(false, '登录')
          // this.getCodeImg()
        })

      } catch (error) {
        this.setBtnStatus(false, '登录')
      }
    },
    check (rule, value, callback) {
      checkPhone(rule, value, callback)
    }
  },
  
};
</script>

<style lang="less" scoped>
.marginBottom{
    margin-top: 15px !important;
    width: 80%;
    margin: 0 auto;
    border-bottom: 1px solid #c2c2c2;
}
.v5-layer {
  position: absolute;
  top: 0;
  left: 0;
}
.form {
  .btn {
    .ant-btn {height: 53px;}
  }
  /deep/.ant-input {
    height: 60px;
    line-height: 60px;
    border: none ;
    outline: none;
    box-shadow: none;
  }
  .code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /deep/.ant-input {width: calc(100% - 5px);}
    .ant-btn {height: 40px;}
  }
}
</style>
